// Unpublished Work © 2026 Deere & Company.

const WINDOWS = 'Windows';
const MAC_OS = 'Mac OS';

export function getOsName(): string | undefined {
    const userAgent = navigator.userAgent;

    if (/Windows/i.test(userAgent) && !/Android/i.test(userAgent)) {
        return WINDOWS;
    }

    if (/Macintosh|Mac OS X/i.test(userAgent) && !/iPhone|iPad/i.test(userAgent)) {
        return MAC_OS;
    }

    return undefined;
}
